import React from "react";
import { useMap } from "react-leaflet";
import * as L from "leaflet";

type P = { points: Array<{ latitude?: number; longitude?: number }> };

export const AutoFitBounds: React.FC<P> = ({ points }) => {
  const map = useMap();
  const hasFittedRef = React.useRef(false);
  const userMovedRef = React.useRef(false);

  React.useEffect(() => {
    const onInteract = () => { userMovedRef.current = true; };
    map.on("zoomstart movestart", onInteract);
    return () => { map.off("zoomstart movestart", onInteract); };
  }, [map]);

  React.useEffect(() => {
    if (hasFittedRef.current || userMovedRef.current) return;
    const valid = (points ?? []).filter(p => Number.isFinite(p.latitude) && Number.isFinite(p.longitude));
    if (!valid.length) return;
    const bounds = L.latLngBounds(valid.map(p => [p.latitude!, p.longitude!] as [number, number]));
    map.fitBounds(bounds, { padding: [24, 24] });
    hasFittedRef.current = true;
  }, [map, points]);

  return null;
};
